// Package imports:
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
// Component imports:
import Link from '../../../ui-elements/Link/Link';
import Modal from '../../../ui-elements/Modal/Modal';


const ValuationUnsuccessful: React.FC = () => {
    const [ explanationOpen, setExplanationOpen ] = useState(false);
    const openExplanation = () => setExplanationOpen(true);
    const closeExplanation = () => setExplanationOpen(false);

    return (
        <>
            <Link
                className='more-link'
                url=''
                linkSize='14'
                onClick={(e) => {
                    e.preventDefault();
                    openExplanation();
                }}
            >
                <FontAwesomeIcon icon={faPlus} />
                Hvers vegna?
            </Link>
            <Modal
                show={explanationOpen}
                hasCloseButton
                onHide={closeExplanation}
                header={<h3>Ekki tókst að verðmeta fyrirtæki</h3>}
                body={<div>
                    <p>Keldan styðst við ýmsar forsendur við gerð verðmatsins.<br />Eftirfarandi ástæður gætu valdið því að ekki tekst að verðmeta fyrirtæki:</p>
                    <ul className='blue-dot-list'>
                        <li>Ársreikningar eru of gamlir eða of fáir.</li>
                        <li>Gögn vantar við útreikning ávöxtunarkröfu.</li>
                        <li>Gögn vantar við útreikning frjáls sjóðstreymis.</li>
                        <li>Atvinnugrein fyrirtækis bendir til þess að verðmatsaðferð eigi ekki við.</li>
                        <li>Niðurstöður verðmats eru utan þess sem eðlilegt gæti talist.</li>
                        <li>Ársreikningar eru í öðrum gjaldmiðli en ISK.</li>
                    </ul>
                </div>}
                className='KCL_no-valuation'
            />
        </>
    );
}

export default ValuationUnsuccessful;